module.exports = __webpack_public_path__ + "img/9788950936426.3531abbb.jpg";